// Tiny dev-only logger so we don't litter prod console output while
// still having a breadcrumb when something fails. NEVER use console.log
// directly in catch blocks.
const isDev = typeof process !== "undefined"
  && process.env
  && process.env.NODE_ENV !== "production";

export function logError(scope, err) {
  if (!isDev) return;
  // eslint-disable-next-line no-console
  console.warn(`[${scope}]`, err?.message || err);
}
